import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M21.357 9.85699V12.4285C21.357 12.7855 21.232 13.089 20.982 13.339C20.732 13.589 20.4285 13.714 20.0715 13.714H14.5V19.2855C14.5 19.6425 14.375 19.946 14.125 20.196C13.875 20.446 13.5715 20.571 13.2145 20.571H10.643C10.286 20.571 9.98249 20.446 9.73249 20.196C9.48249 19.946 9.35749 19.6425 9.35749 19.2855V13.714H3.78599C3.42899 13.714 3.12549 13.589 2.87549 13.339C2.62549 13.089 2.50049 12.7855 2.50049 12.4285V9.85699C2.50049 9.49999 2.62549 9.19649 2.87549 8.94649C3.12549 8.69649 3.42899 8.57149 3.78599 8.57149H9.35749V2.99999C9.35749 2.64299 9.48249 2.33949 9.73249 2.08949C9.98249 1.83949 10.286 1.71449 10.643 1.71449H13.2145C13.5715 1.71449 13.875 1.83949 14.125 2.08949C14.375 2.33949 14.5 2.64299 14.5 2.99999V8.57149H20.0715C20.4285 8.57149 20.732 8.69649 20.982 8.94649C21.232 9.19649 21.357 9.49999 21.357 9.85699Z"
        fill="currentColor"
      />
    </>
  ),
})

const Plus: FC<IconProps> = (props) => {
  return <CustomIcon as={PlusIcon} {...props} />
}

export default memo(Plus)
